import React from 'react'
import {
  CartesianGrid,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { FINANCE_GROSS_NET_LINE_COLORS } from '@constants/Dashboard/financeDashboard.constants'
import { formatChartCurrencyKUnits } from '@utils/dashboardFinance.util'

type FinanceGrossNetLineChartProps = {
  data: Array<{ label: string; Gross: number; Net: number }>
  yDomain: [number, number]
  yTicks: number[]
  goalLineValue?: number
  height?: number
  yAxisWidth?: number
}

export function FinanceGrossNetLineChart({
  data,
  yDomain,
  yTicks,
  goalLineValue = 0,
  height = 220,
  yAxisWidth = 36,
}: FinanceGrossNetLineChartProps): React.ReactElement {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 12, right: 8, left: 0, bottom: 8 }}>
        <CartesianGrid
          strokeDasharray="0"
          vertical={false}
          horizontal
          stroke="var(--gray-100)"
        />
        <XAxis
          type="category"
          dataKey="label"
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: 'var(--gray-500)' }}
          tickMargin={8}
        />
        <YAxis
          type="number"
          domain={yDomain}
          ticks={yTicks}
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: 'var(--gray-500)' }}
          tickFormatter={formatChartCurrencyKUnits}
          width={yAxisWidth}
        />
        <ReferenceLine
          y={goalLineValue}
          stroke="var(--blue-500)"
          strokeDasharray="4 4"
          strokeWidth={2}
          label={{
            value: 'Goal',
            position: 'left',
            fontSize: 11,
            fill: 'var(--blue-500)',
          }}
        />
        <Tooltip
          formatter={(value: number, name: string) => [
            formatChartCurrencyKUnits(value),
            name,
          ]}
          contentStyle={{
            fontSize: 12,
            borderRadius: 8,
            border: '1px solid var(--gray-200)',
          }}
          labelFormatter={(label) => String(label)}
        />
        <Line
          type="linear"
          dataKey="Gross"
          name="Gross collection"
          stroke={FINANCE_GROSS_NET_LINE_COLORS.gross}
          strokeWidth={2}
          dot={false}
          connectNulls
        />
        <Line
          type="linear"
          dataKey="Net"
          name="Net collection"
          stroke={FINANCE_GROSS_NET_LINE_COLORS.net}
          strokeWidth={2}
          dot={false}
          connectNulls
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
